// extracted by mini-css-extract-plugin
export var boardmembersgrid = "BoardMembersGrid-module--boardmembersgrid--ef155";
export var contentContainer = "BoardMembersGrid-module--contentContainer--840c1";
export var name = "BoardMembersGrid-module--name--1f757";
export var staffMember = "BoardMembersGrid-module--staffMember--75b6d";
export var staffMembersContainer = "BoardMembersGrid-module--staffMembersContainer--ac0d7";
export var textContainer = "BoardMembersGrid-module--textContainer--cd032";